import FrameComponent from "../components/FrameComponent";
import LoginForm1 from "../components/LoginForm1";
import SocialLogin from "../components/SocialLogin";
import HomeIndicator from "../components/HomeIndicator";

const LoginEmail = () => {
  return (
    <div className="w-full relative bg-light-primary-key-background flex flex-col items-start justify-start gap-[50px] leading-[normal] tracking-[normal] text-center text-base text-light-primary-key-background font-text-regular-lowercase">
      <FrameComponent />
      <section className="flex flex-row items-start justify-start pt-0 px-10 pb-[93px] box-border max-w-full text-left text-21xl text-dark-text font-text-regular-lowercase">
        <div className="flex flex-col items-start justify-start gap-[15px]">
          <h1 className="m-0 relative text-inherit font-semibold font-[inherit]">
            Bạn đã trở lại
          </h1>
          <h3 className="m-0 relative text-5xl font-semibold font-[inherit] text-light-text">
            Đăng nhập để tiếp tục!
          </h3>
        </div>
      </section>
      <LoginForm1 />
      <div className="flex flex-row items-start justify-start py-0 px-10 box-border max-w-full">
        <div className="rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] flex flex-row items-start justify-start py-5 px-[137px] box-border max-w-full mq330:pl-5 mq330:pr-5 mq330:box-border">
          <div className="h-[60px] w-[360px] relative rounded-81xl [background:linear-gradient(90deg,_#ff92d7,_#ffbc92)] hidden max-w-full" />
          <div className="relative z-[1]">Đăng nhập</div>
        </div>
      </div>
      <SocialLogin />
      {/* <HomeIndicator
        homeIndicatorBackgroundColor="#fff"
        homeIndicatorMargin="unset"
        homeIndicatorPosition="unset"
        homeIndicatorRight="unset"
        homeIndicatorBottom="unset"
        homeIndicatorLeft="unset"
        homeIndicatorTop="unset"
        homeIndicatorMarginTop="unset"
      /> */}
    </div>
  );
};

export default LoginEmail;
